
// Utility functions for blog-related operations

/**
 * Extracts a plain text excerpt from HTML content
 * @param htmlContent The HTML content to extract text from
 * @param maxLength Maximum length of the excerpt
 * @returns Plain text excerpt
 */
export const extractExcerpt = (htmlContent: string, maxLength: number = 200): string => {
  // Create a temporary element to strip HTML tags
  const tempElement = document.createElement('div');
  tempElement.innerHTML = htmlContent;
  
  // Get the text content and trim it
  let excerpt = tempElement.textContent || tempElement.innerText || '';
  excerpt = excerpt.trim().replace(/\s+/g, ' ');
  
  // Limit to maxLength characters
  if (excerpt.length > maxLength) {
    excerpt = excerpt.substring(0, maxLength).trim() + '...';
  }
  
  return excerpt;
};
